webpackJsonp([39],{

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'also-read',
  computed: {
    node: function node() {
      return (0, _get2.default)(this, 'article.node', {});
    },
    title: function title() {
      return (0, _utilities.getSocialHeadLingAsTitle)(this.node);
    }
  },
  props: {
    article: {
      type: Object,
      default: {}
    }
  }
};

/***/ }),

/***/ 1468:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".also-read-wrapper[data-v-02cc2cc0]{margin-top:.875rem;margin-left:1.6875rem;margin-right:1.6875rem}@media (min-width:1024px){.also-read-wrapper[data-v-02cc2cc0]{margin-top:2.5rem}}.also-read-article-wrapper[data-v-02cc2cc0],.also-read-wrapper[data-v-02cc2cc0]{margin-bottom:.875rem}@media (min-width:1024px){.also-read-article-wrapper[data-v-02cc2cc0],.also-read-wrapper[data-v-02cc2cc0]{margin-bottom:2.5rem}}.also-read-tag[data-v-02cc2cc0]{color:#fff;position:relative;background-color:#00cbcc;text-transform:uppercase;font-weight:700;display:inline-block;font-size:.875rem;line-height:1.625rem;padding:.125rem .75rem 0 1rem;font-family:Barlow,sans-serif}.also-read-tag[data-v-02cc2cc0]:before{width:0;height:0;border-style:solid;border-width:.75rem 0 0 .75rem;border-color:transparent transparent transparent #fff;content:\"\";position:absolute;left:0;bottom:0}.also-read-content[data-v-02cc2cc0]{border-style:solid;border-color:#00cbcc;border-width:.25rem 0}.also-read-content-title[data-v-02cc2cc0]{display:inline-block;font-family:Barlow,sans-serif;font-size:1.25rem;font-weight:700;line-height:1.625rem;color:#000;-webkit-text-decoration:underline #f8008e;text-decoration:underline #f8008e;padding-top:.4375rem;padding-bottom:.8125rem}", "", {"version":3,"sources":["/app/components/article/amp/AmpAlsoRead.vue"],"names":[],"mappings":"AAgCA,oCACE,mBAAqB,AACrB,sBAAuB,AACvB,sBAAwB,CAEzB,AACD,0BACA,oCACM,iBAAmB,CACxB,CACA,AACD,gFAEE,qBAAwB,CAEzB,AACD,0BACA,gFAEM,oBAAsB,CAC3B,CACA,AACD,gCACE,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,yBAA0B,AAC1B,gBAAkB,AAClB,qBAAsB,AACtB,kBAAoB,AACpB,qBAAsB,AACtB,8BAAiC,AACjC,6BAAkC,CACnC,AACD,uCACI,QAAS,AACT,SAAU,AACV,mBAAoB,AACpB,+BAAkC,AAClC,sDAA0D,AAC1D,WAAY,AACZ,kBAAmB,AACnB,OAAQ,AACR,QAAU,CACb,AACD,oCACE,mBAAoB,AACpB,qBAAsB,AACtB,qBAAwB,CACzB,AACD,0CACI,qBAAsB,AACtB,8BAAkC,AAClC,kBAAmB,AACnB,gBAAkB,AAClB,qBAAsB,AACtB,WAAe,AACf,0CAA2C,AACnC,kCAAmC,AAC3C,qBAAuB,AACvB,uBAA0B,CAC7B","file":"AmpAlsoRead.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.also-read-wrapper[data-v-02cc2cc0] {\n  margin-top: 0.875rem;\n  margin-left: 1.6875rem;\n  margin-right: 1.6875rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.also-read-wrapper[data-v-02cc2cc0] {\n      margin-top: 2.5rem;\n}\n}\n.also-read-article-wrapper[data-v-02cc2cc0],\n.also-read-wrapper[data-v-02cc2cc0] {\n  margin-bottom: 0.875rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.also-read-article-wrapper[data-v-02cc2cc0],\n    .also-read-wrapper[data-v-02cc2cc0] {\n      margin-bottom: 2.5rem;\n}\n}\n.also-read-tag[data-v-02cc2cc0] {\n  color: #FFFFFF;\n  position: relative;\n  background-color: #00cbcc;\n  text-transform: uppercase;\n  font-weight: bold;\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 1.625rem;\n  padding: 0.125rem 0.75rem 0 1rem;\n  font-family: \"Barlow\", sans-serif;\n}\n.also-read-tag[data-v-02cc2cc0]:before {\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0.75rem 0 0 0.75rem;\n    border-color: transparent transparent transparent #FFFFFF;\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n.also-read-content[data-v-02cc2cc0] {\n  border-style: solid;\n  border-color: #00cbcc;\n  border-width: 0.25rem 0;\n}\n.also-read-content-title[data-v-02cc2cc0] {\n    display: inline-block;\n    font-family: \"Barlow\", sans-serif;\n    font-size: 1.25rem;\n    font-weight: bold;\n    line-height: 1.625rem;\n    color: #000000;\n    -webkit-text-decoration: underline #f8008e;\n            text-decoration: underline #f8008e;\n    padding-top: 0.4375rem;\n    padding-bottom: 0.8125rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1468);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("dd81e62c", content, true, {});

/***/ }),

/***/ 1682:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1557)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1338),
  /* template */
  __webpack_require__(1724),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02cc2cc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1724:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "also-read-wrapper"
  }, [_c('div', {
    class: ("also-read-article-wrapper " + (_vm.article.isLast ? 'last': ''))
  }, [_c('span', {
    staticClass: "also-read-tag"
  }, [_vm._v("also read")]), _c('div', {
    staticClass: "also-read-content"
  }, [_c('a', {
    staticClass: "also-read-content-title",
    attrs: {
      "href": _vm.node.relative_url
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 39.cd66e8a5ab7c77ad94ef.js